/**
 * 判断当前环境是否为新建页环境
 *
 * @returns
 */
export const checkWpsEnvIsNewPage = () => {
  return window.__wpsoffice_environment === 'wpsnewapp';
};
